import { Controller2 } from './Controller2';
import { applySelectionAttributes } from './applySelectionAttributes';

export function handleMouseDownEvent(this: Controller2, ev: MouseEvent) {
  const target = ev.target;

  if (target instanceof HTMLElement) {
    const cell = target.closest('th,td');
    const row = target.closest('tr');
    const table = target.closest('table');

    if (cell && row && table) {
      const state = this.getState();

      const rowIndex = Number.parseInt(row.dataset.rowindex || 'a', 10);
      const colIndex = Number.parseInt(cell.ariaColIndex || 'a', 10);
      if (!isNaN(rowIndex) && !isNaN(colIndex)) {
        if ((!ev.ctrlKey && !ev.shiftKey) || state.isMultiple === false) {
          state.selectedRows = [rowIndex];
        } else if (ev.ctrlKey) {
          if (state.selectedRows.includes(rowIndex)) {
            state.selectedRows = state.selectedRows.filter(
              (c) => c !== rowIndex,
            );
          } else {
            state.selectedRows = [...state.selectedRows, rowIndex];
          }
        } else if (ev.shiftKey) {
          const previousFocused = this.getState().focusedRow;
          state.selectedRows = [...state.selectedRows];

          const min = Math.min(previousFocused, rowIndex);
          const max = Math.max(previousFocused, rowIndex);

          for (let i = min; i <= max; i++) {
            state.selectedRows.push(i);
          }
        }

        state.focusedColumn = colIndex;
        state.focusedRow = rowIndex;
        state.isFocused = true;

        applySelectionAttributes(table, this.getState(), state);
        this.setState(state);

        this.events.emit('onRowClick', [
          { row: state.rows[state.focusedRow], index: state.focusedRow },
          state.focusedRow,
        ]);
      } else {
        console.warn('Cannot parse rowIndex or colIndex');
      }
    } else {
      console.warn('Cannot find cell, row or table');
    }
  }
}
